import React from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../../lib/utils';

export const ArticleCard = ({ 
  article, 
  variant = 'default', // default, horizontal
  className = ''
}) => {
  const imageUrl = article.hero_image 
    ? getImageUrl(article.hero_image) 
    : `https://images.unsplash.com/photo-1648260029310-5f1da359af9d?w=600&h=400&fit=crop`;

  // Horizontal variant - shows image + headline only
  if (variant === 'horizontal') {
    return (
      <Link 
        to={`/article/${article.slug}`}
        className={`group flex gap-4 ${className}`}
        data-testid={`article-card-${article.id}`}
      >
        <div className="w-24 h-24 md:w-32 md:h-32 flex-shrink-0 overflow-hidden rounded-sm">
          <img
            src={imageUrl}
            alt={article.title}
            className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
            loading="lazy"
            onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1648260029310-5f1da359af9d?w=600&h=400&fit=crop'; }}
          />
        </div>
        <div className="flex-1 min-w-0 flex items-center">
          <h3 className="font-serif text-base md:text-lg font-semibold leading-tight line-clamp-3 group-hover:text-primary transition-colors">
            {article.title}
          </h3>
        </div>
      </Link>
    );
  }

  // Default card - shows image + headline ONLY (no excerpt, author, date, category)
  return (
    <Link 
      to={`/article/${article.slug}`}
      className={`group block ${className}`}
      data-testid={`article-card-${article.id}`}
    >
      <div className="aspect-[4/3] overflow-hidden rounded-sm mb-4">
        <img
          src={imageUrl}
          alt={article.title}
          className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
          onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1648260029310-5f1da359af9d?w=600&h=400&fit=crop'; }}
        />
      </div>
      <div>
        <h3 className="font-serif text-lg md:text-xl font-semibold leading-tight line-clamp-2 group-hover:text-primary transition-colors">
          {article.title}
        </h3>
      </div>
    </Link>
  );
};

export default ArticleCard;
